module.exports = __webpack_public_path__ + "static/img/1.957f35f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/1.png
// module id = M4sf
// module chunks = 0